export default "__VITE_ASSET__DFlc2KWR__"